
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.47 5h7.06c1.024 0 1.135.019 1.208.04.122.036.236.095.336.173.06.047.14.126.734.96l1.303 1.824c.42.588.672.942.842 1.222.158.26.17.336.17.336a1 1 0 01-.032.537s-.022.075-.21.313c-.203.258-.496.579-.984 1.111l-4.833 5.272c-.637.696-1.032 1.124-1.352 1.419-.15.138-.249.214-.313.256a.6.6 0 01-.07.042h-.004a1 1 0 01-.65 0h-.003a2.672 2.672 0 01-.383-.298c-.321-.295-.716-.723-1.353-1.418l-4.833-5.273c-.488-.533-.78-.853-.984-1.111-.187-.237-.21-.312-.21-.313a1 1 0 01-.032-.537s.013-.078.17-.336c.17-.28.422-.634.842-1.222l1.303-1.824c.595-.834.675-.913.735-.96a1 1 0 01.336-.173C7.335 5.02 7.446 5 8.47 5zm-3.906.01c.526-.736.789-1.104 1.128-1.37A3 3 0 016.7 3.121C7.113 3 7.566 3 8.47 3h7.06c.905 0 1.357 0 1.77.121a3 3 0 011.008.519c.34.266.602.634 1.128 1.37l1.303 1.824c.806 1.129 1.21 1.693 1.34 2.301a3 3 0 01-.099 1.612c-.203.587-.672 1.098-1.609 2.12l-4.833 5.273c-1.227 1.34-1.841 2.009-2.562 2.257a3 3 0 01-1.953 0c-.72-.248-1.334-.918-2.561-2.257l-4.833-5.272c-.937-1.023-1.406-1.534-1.61-2.121a3 3 0 01-.098-1.612c.131-.608.534-1.172 1.34-2.3L4.564 5.01zM8 8a1 1 0 100 2H16a1 1 0 100-2H8z","fill":"currentColor"}})])
          )
        }
      }
    